const isAuth = (state: IRootState): boolean => {
    return !!state.user.access;
};
export default isAuth;
